import Vue from 'vue'

// axios
import axios from 'axios'

const edgeAxios = axios.create({
  baseURL: 'https://app.e-farm.site/edge-api',
  timeout: 3500,
  headers: { 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS' },
})

Vue.prototype.$http = edgeAxios

export default edgeAxios
